const dompurifyConfig = {
  ADD_ATTR: ['target', 'rel', 'id', 'data-cols', 'data-block6', 'data-side'],
  FORBID_TAGS: ['script', 'style'],
  FORBID_ATTR: [
    'style',
    'onerror',
    'onload',
    'onclick',
    'onmouseover',
    'onmouseenter',
    'onmouseleave',
    'onfocus',
    'onblur',
    'onsubmit',
    'onchange',
    'oninput',
  ],
};

export { dompurifyConfig };
